/** Group protocol — SPEC §13 */

export const GROUP_MAX_MEMBERS_V1 = 32;
export const CONTENT_TYPE_GROUP = 10;

export type GroupRole = "member" | "admin";

export type GroupWirePayload =
  | {
      op: "group-key";
      groupId: string;
      epoch: number;
      title: string;
      /** Slim membership — no hybrid/contactId (pad budget; see groupAuth). */
      members: { identityKeyHex: string; displayName: string; role: GroupRole }[];
      senderKeyB64: string;
      /** Required: admin messaging pubkey hex */
      adminIdentityKeyHex: string;
      /** Required: Ed25519 sig hex over canonical group-key bytes */
      adminSigHex: string;
    }
  | {
      op: "group-msg";
      groupId: string;
      epoch: number;
      /** AES-GCM ciphertext of plaintext, base64 (iv||ct) */
      ctB64: string;
      replyToEventId?: string;
    }
  | {
      op: "group-meta";
      groupId: string;
      epoch: number;
      system: string;
    };

export const GROUP_FEATURE_STATUS = {
  pairwiseFanout: "implemented",
  senderKeys: "implemented",
  mls: "roadmap",
  availableInUi: true,
  gateMessage: "",
} as const;

export function encodeGroupPayload(p: GroupWirePayload): string {
  return JSON.stringify(p);
}

export function decodeGroupPayload(body: string): GroupWirePayload | null {
  try {
    const raw = JSON.parse(body) as GroupWirePayload;
    if (!raw || typeof raw !== "object" || !("op" in raw)) return null;
    return raw;
  } catch {
    return null;
  }
}
